import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "app-container-color" }
const _hoisted_2 = { class: "app-wrapper" }
const _hoisted_3 = { class: "app-wrapper-side" }
const _hoisted_4 = { class: "main-container" }
const _hoisted_5 = { class: "app-main" }

import {
  onMounted,
  computed,
  ref,
  watch,
  reactive,
  getCurrentInstance,
} from "vue";
import { useRoute } from "vue-router";
import jwtDecode from "jwt-decode";
// import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";
// import moment from "moment";
// moment.locale("zh-cn");
import store from "./store";
import Sidebar from "./components/Sidebar.vue";
import RisfondHead from "./components/RisfondHead.vue";
import { getApplyUserInfo } from "@/api/api";
import { GetCurrentMyPageList } from "@/api/index";

import zhCN from '@/types/ZhLocale';
type Info = { UserId: number | string; [key: string]: any };

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const locale = ref(zhCN);
const isLoading = computed(() => store.getters.getLoadingStatus);
const isLogin = computed(() => store.getters.getLogin);

const route = useRoute();
const data = reactive<{
  title: string;
  len: number;
  tokenInfo: unknown;
  inited: boolean;
  locale: string;
}>({
  title: "",
  len: 0,
  tokenInfo: {},
  inited: false,
  locale: "",
});

const show_menu = ref<boolean>(false);
onMounted(async () => {
  // 友盟埋点
  const script = document.createElement("script");
  script.type = "text/javascript";
  script.src = "https://s4.cnzz.com/z_stat.php?id=1281279036&web_id=1281279036";
  document.body.appendChild(script);
});

watch(
  route,
  async () => {
    data.title = String(route.meta.title || "锐仕方达开业系统");
    const { query } = route;
    const getSession = sessionStorage.getItem("token");
    if (getSession) {
      const info = jwtDecode(getSession) as Info;
      data.tokenInfo = info;
      store.dispatch("setStaffInfo", info);
      await baseInfo(info);
      getList();
    } else {
      if (query.ticket && !data.len) {
        data.len++;
        // getToken(query.ticket);
      }
      if (query.ticket) {
        localStorage.setItem("name", JSON.stringify({ t: query.ticket }));
      }
    }
  },
  {
    deep: true,
  }
);
const getList = async () => {
  const { Success, Data } = await GetCurrentMyPageList();

  if (Success) {
    store.commit("setWaitList", Data.ApproveCount);
    store.commit("setToList", Data.ToCCCount);
  }
};

//获取用户简单信息
const baseInfo = async (val: Info) => {
  const { Success, Data } = await getApplyUserInfo({
    staffId: val.UserId,
  });
  sessionStorage.setItem("staffId", val.UserId as string);
  if (Success) {
    store.dispatch("setStaffId", val.UserId);
    store.dispatch("setSimpleInfo", Data);
    sessionStorage.setItem("CompanyId", Data.CompanyId);
    sessionStorage.setItem("SalaryDataAccess", Data.SalaryDataAccess);
    let Company = {
      CompanyId: Data.CompanyId,
      CompanyName: Data.CompanyName,
    };
    sessionStorage.setItem("Company", JSON.stringify(Company));
    data.inited = false; //需要等到信息返回后再进入页面
  }
};

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createBlock(_component_a_config_provider, {
    locale: locale.value,
    theme: { primaryColor: '#1867ad' }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(RisfondHead),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_unref(isLogin))
              ? (_openBlock(), _createBlock(Sidebar, {
                  key: 0,
                  class: "sidebar-container"
                }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_a_spin, {
                  spinning: _unref(isLoading),
                  tip: "跳转中...",
                  size: "large",
                  class: "app-content"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_view, null, {
                      default: _withCtx(({ Component, route }) => [
                        (_openBlock(), _createBlock(_KeepAlive, null, [
                          (route.meta.keepAlive)
                            ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                                key: route.path
                              }))
                            : _createCommentVNode("", true)
                        ], 1024)),
                        (!route.meta.keepAlive)
                          ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), { key: 0 }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["spinning"])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["locale"]))
}
}

})